import React, { useCallback, useContext, useEffect, useRef, useState } from "react";

import "./CustomAccordion.css";
import mockAccordion from '../../../jsonMock/MockAccordion.json'
import { TableBody } from "./TableBody";
import { Corporate } from "../../types/types";
import useIntersection from "../../../hook/useIntersection";
import { AppGeneralContext } from "../../../shared/GeneralContext/GeneralContext";
import clsx from "clsx";
import { StartupStartMatchReq } from "components/types/Api";
import useMediaQuery from "hook/useMediaQuery";
import { MediaTablet } from "api/const/MediaQuery";

interface iCustomTable {
  data:Corporate[]
  askForaMatch: (userId: string, companyName: string, userName: string, companyId: string) => void
  selectedId?: string
  setSelectedId?: (selectedId: string) => void
}


export const CustomTable = ({ data, askForaMatch, selectedId, setSelectedId }: iCustomTable) => {
  const { startUp } = useContext(AppGeneralContext)
  const tablet = useMediaQuery(MediaTablet)

  const {  isLoadingCorporates, numberMatchRequest } = useContext(AppGeneralContext)

  return (

    <div className={clsx("d-flex flex-column mt-4 tableContainer mb-5",
      { 
      //   "disabled": 
      // // startUp.currentPlan?.monthMatches === 0 ||
      //  numberMatchRequest <= 0 
      })}
    >
      {!tablet &&
      <div className="d-flex flex-row  justify-content-between tHead tablePadding">
        <div className="t-col Hcorporates ps-3 ">Corporate</div>
        <div className="t-col Ncontact">N°Contacts</div>
        <div className="t-col Hactions">Actions</div>
      </div>
      }

      <TableBody data={data} isLoading={isLoadingCorporates} askForaMatch={askForaMatch} selectedId={selectedId} setSelectedId={setSelectedId}/>
    </div>
  );
}



